export default "__VITE_ASSET__da857246__"